<template>
  <div class="c-select">
		<validation-message
			:valid="valid"
			:invalid="invalid"
			:validationMessage="validationMessage"
		>

			<div class="c-select__group">
				<div class="c-select__container">
					<label class="c-select__label" :for="id">
						<svg class="c-select__icon" aria-hidden="true" focusable="false">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#chevron-down"></use>
						</svg>
						<select
							class="c-select__field"
							:class="{ 'is-active': hasValue }"
              :id="id" 
							:name="id"
							:required="required"
							:disabled="disabled"
							v-model="internalValue"
              @change="valueUpdated">
							<option v-if="placeholder" disabled selected hidden>{{ placeholder }}</option>
							<option
								v-for="option in options"
								:key="option.value"
								:value="option.value">
								{{ option.label }}
							</option>
						</select>
            <span class="visually-hidden">{{ label }}</span>
            <span class="c-select__label-text" aria-hidden="true">{{ placeholder ? placeholder : label }}  <span v-if="required" class="c-select__required"> *</span></span>
					</label>
				</div>
			</div>

		</validation-message>
    <div v-if="tooltip" class="c-tooltip">
      <ToolTip />
    </div>
  </div>
</template>

<script>
import ValidationMessage from '../../../../base/validation-message/ValidationMessage.vue';
import ToolTip from '../../_contact-us-rap/_vue/ToolTip.vue'

export default {
	components: { ValidationMessage, ToolTip },
  inheritAttrs: false,
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
		options: {
      required: true,
      type: Array,
    },
    required: {
      required: false,
      type: Boolean,
    },
		placeholder:{
			required: false,
      type: String,
			default: null
		},
		disabled: {
      required: false,
      type: Boolean,
    },
    tooltip: {
      required: false,
      type: Boolean,
    },
		value: {
      type: [String, Number],
    },
		valid: {
      type: Boolean,
      default: null
    },
    invalid: {
      type: Boolean,
      default: null
    },
    validationMessage: {
      required: false,
      type: String,
    },
  },
  computed: {
		hasValue(){
			return this.internalValue !== '' && this.internalValue !== null && this.internalValue !== undefined;
		}
  },
	watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  methods: {
    valueUpdated() {
      const selectedOption = this.options.find((option) => option.value === this.internalValue);
      this.$emit('change', selectedOption);
    },
  },
	
}
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/forms/select/SelectDropdown.vue